import * as React from 'react';
import { useQueryClient } from 'react-query';

import {
  useGetConnectionByIndexQuery,
  useListConnectionUsersQuery,
  useListOrganizationConnectionAccessQuery,
  useListOrganizationConnectionsQuery,
  useSavedConnectionsQuery,
} from 'src/ui/graph/types';

export const useInvalidateConnections = (org: string) => {
  const queryClient = useQueryClient();

  return React.useCallback(() => {
    if (org) {
      queryClient.invalidateQueries(
        useListOrganizationConnectionsQuery.getKey({ org_domain: org })
      );
      queryClient.invalidateQueries(
        useSavedConnectionsQuery.getKey({ org_domain: org })
      );
    } else {
      queryClient.invalidateQueries('listConnectionsByEndpoint');
      queryClient.invalidateQueries(useSavedConnectionsQuery.getKey());
    }
  }, [org, queryClient]);
};

export const useInvalidateConnection = (org: string, id = '', index = -1) => {
  const queryClient = useQueryClient();
  const invalidateConnections = useInvalidateConnections(org);

  return React.useCallback(() => {
    invalidateConnections();
    if (org) {
      queryClient.invalidateQueries(
        useListOrganizationConnectionAccessQuery.getKey({ org_domain: org, id })
      );
      queryClient.invalidateQueries(
        useGetConnectionByIndexQuery.getKey({ org_domain: org, index })
      );
    } else {
      queryClient.invalidateQueries(useListConnectionUsersQuery.getKey({ id }));
      queryClient.invalidateQueries(
        useGetConnectionByIndexQuery.getKey({ index })
      );
    }
  }, [id, index, invalidateConnections, org, queryClient]);
};
